import script from "./singleNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./singleNotification.vue?vue&type=script&setup=true&lang=js"

import "./singleNotification.vue?vue&type=style&index=0&id=94aa9eee&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94aa9eee"]])

export default __exports__